module.exports = __webpack_public_path__ + "img/fall-1@2x.c710d790.png";